import React from "react";
import { Dropdown, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import SchoolSwitchInput from "../Inputs/SchoolSwitchInput";
import PermissionComponentCheck from "../PermissionComponents/PermissionComponentCheck";
import { TabStopAnchor } from "../Menus/ScreenReaderNavigator";

const renderUserName = (currentUser) => {
  if (!currentUser) {
    return <>Not logged in</>;
  } else if (currentUser) {
    return (
      <>
        {currentUser.firstName} {currentUser.lastName}
      </>
    );
  }
};

const renderAidYearOptions = (aidYears) => {
  return aidYears.map((aidYear) => {
    var prevYear = parseInt(aidYear) - 1;
    return (
      <option key={aidYear} value={aidYear}>
        {prevYear}-{aidYear}
      </option>
    );
  });
};

const RenderAidYear = (props) => {
  let aidYears = useSelector((state) => state.school.aidYears);
  let global = useSelector((state) => state.global);
  //if multiple aid years are available, render a dropdown of options
  if (!aidYears || aidYears.length === 0) {
    return <span className="ml-2">{global.aidYearString}</span>;
  } 
  else if (aidYears.length === 1) {
    const defaultAidYear = aidYears[0];
    const prevYear = parseInt(defaultAidYear) - 1;
    return <span className="ml-2">{prevYear}-{defaultAidYear}</span>;
  } 
  else {
    return (
      <Form className="inline ml-1" inline>
        <Form.Control
          id="aidYearDropdown"
          aria-label="Aid Year"
          onChange={(e) => props.updateAidYear(e.target.value, null, false)}
          value={global.aidYear}
          as="select"
        >
          {renderAidYearOptions(aidYears)}
        </Form.Control>
      </Form>
    );
  }
};

const SchoolBadge = (props) => {
  return (
    <div id="schoolBadge">
      <div className="inline">
        <SchoolSwitchInput />
        <RenderAidYear updateAidYear={props.updateAidYear} />
      </div>

      <div className="text-right">
        <PermissionComponentCheck
          requiredPermission="SETTINGS_VIEW"
          denyAction="hide"
        >
          <Dropdown alignRight className="menuIcon inline">
            <Dropdown.Toggle as="i" id="dropdown-basic">
              <TabStopAnchor style={{ color: "unset" }}><i className="menuIcon fas fa-cog badgeIcon" /></TabStopAnchor>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {/* <p className="dropdownLabel">System Health</p> */}
              {/* <Dropdown.Divider /> */}
              <p className="dropdownLabel">System Configuration</p>
              <PermissionComponentCheck
                requiredPermission="POVERTY_LEVELS_VIEW"
                denyAction="hide"
              >
                <Dropdown.Item as={Link} to="/povertyLevels">
                  Poverty Levels
                </Dropdown.Item>{" "}
              </PermissionComponentCheck>
              <PermissionComponentCheck
                requiredPermission="USER_SETTINGS_VIEW"
                denyAction="hide"
              >
                <Dropdown.Item as={Link} to="/userSettings">
                  User Settings
                </Dropdown.Item>{" "}
              </PermissionComponentCheck>
              <PermissionComponentCheck
                requiredPermission="ADD_SCHOOL_SETTINGS_VIEW"
                denyAction="hide"
              >
                <Dropdown.Item as={Link} to="/addSchool">
                  Add School
                </Dropdown.Item>{" "}
              </PermissionComponentCheck>
              <PermissionComponentCheck
                requiredPermission="JOBS_PAGE_VIEW"
                denyAction="hide"
              >
                <Dropdown.Item as={Link} to="/jobs">
                  Jobs
                </Dropdown.Item>{" "}
              </PermissionComponentCheck>
                <Dropdown.Item as={Link} to="/correctionsdisplay">
                  Corrections Display
                </Dropdown.Item>{" "}
            </Dropdown.Menu>
          </Dropdown>
          </PermissionComponentCheck>
          <Dropdown alignRight className="menuIcon inline">
            <Dropdown.Toggle as="i" id="dropdown-basic">
              <TabStopAnchor style={{ color: "unset" }}><i className="fas fa-user badgeIcon" /></TabStopAnchor>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <p className="ml-2">Logged On as:</p>
              <p className="ml-2">
                <strong>{renderUserName(props.auth.ssoUser)}</strong>
              </p>
              <Dropdown.Item onClick={() => props.signOut()}>
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

      </div>
    </div>
  );
};

export default SchoolBadge;
